import gql from "graphql-tag";

export const createPasswordResetRequest = gql`
  mutation CreatePasswordResetRequest($email: String!) {
    createPasswordResetRequest(data: { user: { connect: { email: $email } } }) {
      createdAt
    }
  }
`;
